module.exports = __webpack_public_path__ + "img/step-6.1a6dc9ba.jpg";